import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  useMemo,
} from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import ModalComponent from "./ModalComponent";
import { useDispatch, useSelector } from "react-redux";
import CONSTANTS from "../util/constants";
import { DataInput } from "./DataComponent";
import * as XLSX from "xlsx";
import Encrypt from "./../util/encrypt";
import DeleteModalComponent from "./DeleteModalCompo";

const UserManagementComp = () => {
  const dispatch = useDispatch();
  const gridRef = useRef();
  const rowDataUser = useSelector((state) => state.userManagement.getUserData);
  const useRole = useSelector((state) => state.userManagement.getUserRole);
  const divisionSelectedTemp = useSelector(
    (state) => state.division.divisionSelected
  );

  const [modalShow, isModalShow] = useState(false);
  const [modalShowDelete, isModalShowDelete] = useState(false);
  const [cellData, setCellClickData] = useState(null);
  const [rowData, setRowData] = useState([]);
  const [columnDefs, setColumnDef] = useState([]);
  const [loginResponse, setLoginResponse] = useState(null);

  useEffect(() => {
    let localstorageLR = localStorage.getItem("L_R");
    if (localstorageLR) {
      let data = localstorageLR ? Encrypt.dycryptData(localstorageLR) : "";
      let loginResponse = localstorageLR
        ? JSON.parse(data) != "" || JSON.parse(data) != null
          ? JSON.parse(data)
          : ""
        : "";
      setLoginResponse(loginResponse);
    }

    setCellClickData(null);

    dispatch({
      type: CONSTANTS.CONSTANTS_USER_MANAGEMENT.GET_USER_MANAGEMENT_API_CALL,
    });

    dispatch({
      type: CONSTANTS.CONSTANTS_USER_MANAGEMENT
        .GET_USER_ROLES_MANAGEMENT_API_CALL,
    });
  }, []);

  useEffect(() => {
    if (rowDataUser && rowDataUser.length > 0 && rowDataUser != "Failed") {
      let obj;
      let filterData = rowDataUser?.filter((item) => {
        return (
          divisionSelectedTemp?.value === item.division_id && item?.is_active
        );
      });
      setRowData(filterData);
    }
  }, [rowDataUser]);

  useEffect(() => {
    let roles = [];

    setColumnDef([
      {
        headerName: "Contact Info",
        children: [
          {
            field: "firstName",
            filter: true,
            resizable: true,
            flex: 1,
            width: 100,
            minWidth: 150,
            maxWidth: 200,
          },
          {
            field: "lastName",
            filter: true,
            resizable: true,
            flex: 1,
            width: 100,
            minWidth: 150,
            maxWidth: 200,
          },
          {
            field: "email",
            filter: true,
            resizable: true,
            flex: 1,
            width: 100,
            minWidth: 250,
            maxWidth: 200,
          },
        ],
      },
      {
        headerName: "Permission",
        field: "userRoles",
        children: [
          {
            headerName: CONSTANTS.CONSTANTS_USER_ROLES.ADMIN,
            field: "is_active",
            filter: true,
            resizable: true,
            flex: 1,
            cellRenderer: cellAdminRender,
            width: 100,
            minWidth: 150,
            maxWidth: 200,
          },
          {
            headerName: CONSTANTS.CONSTANTS_USER_ROLES_HEADER_NAME.RHADMIN,
            field: "is_active",
            filter: true,
            resizable: true,
            flex: 1,
            cellRenderer: cellRHAdminRender,
            width: 100,
            minWidth: 150,
            maxWidth: 200,
          },
          {
            headerName: CONSTANTS.CONSTANTS_USER_ROLES.DISPATCH,
            field: "is_active",
            filter: true,
            resizable: true,
            flex: 1,
            cellRenderer: cellRHUserRender,
            width: 100,
            minWidth: 150,
            maxWidth: 200,
          },
          {
            headerName: CONSTANTS.CONSTANTS_USER_ROLES_HEADER_NAME.RHUSER,
            field: "is_active",
            filter: true,
            resizable: true,
            flex: 1,
            cellRenderer: cellSuperRender,
            width: 100,
            minWidth: 150,
            maxWidth: 200,
          },
          {
            headerName: CONSTANTS.CONSTANTS_USER_ROLES.VIEWONLY,
            field: "is_active",
            filter: true,
            resizable: true,
            flex: 1,
            cellRenderer: cellVIEWONLYRender,
            width: 100,
            minWidth: 150,
            maxWidth: 200,
          },
          {
            headerName: CONSTANTS.CONSTANTS_USER_ROLES.DRIVER,
            field: "isChecked8",
            filter: true,
            resizable: true,
            flex: 1,
            cellRenderer: cellDriverRender,
            width: 100,
            minWidth: 150,
            maxWidth: 200,
          },
        ],
      },
      {
        headerName:
          loginResponse &&
          (loginResponse?.user?.userRoles[0]?.user_role_name ==
            CONSTANTS.CONSTANTS_USER_ROLES.ADMIN ||
            loginResponse?.user?.userRoles[0]?.user_role_name ==
              CONSTANTS.CONSTANTS_USER_ROLES.RHADMIN)
            ? "Actions"
            : "",
        children: [
          {
            field: "",
            filter: true,
            resizable: true,
            flex: 1,
            cellRenderer: cellImageRender,
            width: 100,
            minWidth: 150,
            maxWidth: 200,
          },
          {
            field: "",
            filter: true,
            resizable: true,
            flex: 1,
            cellRenderer: cellCancelImageRender,
            width: 100,
            minWidth: 150,
            maxWidth: 200,
          },
        ],
      },
    ]);
  }, [loginResponse]);

  const cellImageRender = (params) => {
    return loginResponse &&
      (loginResponse?.user?.userRoles[0]?.user_role_name ==
        CONSTANTS.CONSTANTS_USER_ROLES.ADMIN ||
        loginResponse?.user?.userRoles[0]?.user_role_name ==
          CONSTANTS.CONSTANTS_USER_ROLES.RHADMIN) ? (
      <div
        onClick={() => {
          setCellClickData(params.data);
          showModal(true);
        }}
      >
        <img
          style={{ marginLeft: 20 }}
          src={require("./../assets/Dashboard/actions.png")}
        />
      </div>
    ) : null;
  };

  const cellCancelImageRender = (params) => {
    return loginResponse &&
      (loginResponse?.user?.userRoles[0]?.user_role_name ==
        CONSTANTS.CONSTANTS_USER_ROLES.ADMIN ||
        loginResponse?.user?.userRoles[0]?.user_role_name ==
          CONSTANTS.CONSTANTS_USER_ROLES.RHADMIN) ? (
      <div
        onClick={() => {
          setCellClickData(params.data);
          showModalDelete(true);
        }}
      >
        <img
          style={{ marginLeft: 20 }}
          src={require("./../assets/Dashboard/cancel.png")}
        />
      </div>
    ) : null;
  };

  const cellAdminRender = (params) => {
    let isCheckedData = params.data.userRoles
      ? params.data.userRoles.filter(
          (item) => item.user_role_name == CONSTANTS.CONSTANTS_USER_ROLES.ADMIN
        ).length
        ? true
        : false
      : false;

    return isCheckedData ? (
      <img src={require("./../assets/Dashboard/check.png")}></img>
    ) : null;
  };

  const cellRHAdminRender = (params) => {
    let isCheckedData = params.data.userRoles
      ? params.data.userRoles.filter(
          (item) =>
            item.user_role_name == CONSTANTS.CONSTANTS_USER_ROLES.RHADMIN
        ).length
        ? true
        : false
      : false;
    return isCheckedData ? (
      <img src={require("./../assets/Dashboard/check.png")}></img>
    ) : null;
  };

  const cellRHUserRender = (params) => {
    let isCheckedData = params.data.userRoles
      ? params.data.userRoles.filter(
          (item) =>
            item.user_role_name == CONSTANTS.CONSTANTS_USER_ROLES.DISPATCH
        ).length
        ? true
        : false
      : false;
    return isCheckedData ? (
      <img src={require("./../assets/Dashboard/check.png")}></img>
    ) : null;
  };

  const cellSuperRender = (params) => {
    let isCheckedData = params.data.userRoles
      ? params.data.userRoles.filter(
          (item) => item.user_role_name == CONSTANTS.CONSTANTS_USER_ROLES.RHUSER
        ).length
        ? true
        : false
      : false;
    return isCheckedData ? (
      <img src={require("./../assets/Dashboard/check.png")}></img>
    ) : null;
  };

  const cellVIEWONLYRender = (params) => {
    let isCheckedData = params.data.userRoles
      ? params.data.userRoles.filter(
          (item) =>
            item.user_role_name == CONSTANTS.CONSTANTS_USER_ROLES.VIEWONLY
        ).length
        ? true
        : false
      : false;
    return isCheckedData ? (
      <img src={require("./../assets/Dashboard/check.png")}></img>
    ) : null;
  };

  const cellDriverRender = (params) => {
    let isCheckedData = params.data.userRoles
      ? params.data.userRoles.filter(
          (item) => item.user_role_name == CONSTANTS.CONSTANTS_USER_ROLES.DRIVER
        ).length
        ? true
        : false
      : false;
    return isCheckedData ? (
      <img src={require("./../assets/Dashboard/check.png")}></img>
    ) : null;
  };

  const defaultColDef = useMemo(() => ({
    sortable: true,
    resizable: true,
  }));

  const showModal = (isShow) => {
    isModalShow(isShow);
  };
  const showModalDelete = (isShow2) => {
    isModalShowDelete(isShow2);
  };

  const importUser = (file) => {
    const reader = new FileReader();
    const rABS = !!reader.readAsBinaryString;
    reader.onload = (e) => {
      /* Parse data */

      const bstr = e.target.result;
      const wb = XLSX.read(bstr, { type: rABS ? "binary" : "array" });
      /* Get first worksheet */
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      /* Convert array of arrays */
      const data = XLSX.utils.sheet_to_json(ws, { header: 0 });
      /* Update state */
      if (data && data.length > 0) {
        let payload = [];
        for (let i = 0; i < data.length; i++) {
          var permissionArr = [];
          if (data[i].permissions != "" && data[i].permissions != null) {
            permissionArr = data[i].permissions.split(",");
          }
          payload.push({
            email: data[i].email,
            firstName: data[i].firstName,
            lastName: data[i].lastName,
            password: data[i].password,
            permissions: permissionArr,
          });
        }
        dispatch({
          type: CONSTANTS.CONSTANTS_WORKSHEET_MANAGEMENT.USER_BULK_API_CALL,
          payload: { value: payload },
        });
      } else {
        alert("Failed to load data");
      }
    };
    if (rABS) reader.readAsBinaryString(file);
    else reader.readAsArrayBuffer(file);
  };

  return (
    <div className="row">
      {modalShow ? (
        <ModalComponent
          title={cellData != null ? "Edit User" : "Create New User"}
          show={showModal}
          handleClose={showModal}
          isShow={showModal}
          rowDataUser={cellData}
          roles={useRole}
          addUserManagement={true}
          setValue={(value) => {
            console.log("res1", value);

            isModalShow(false);
            if (cellData != null) {
              setCellClickData(null);
              dispatch({
                type: CONSTANTS.CONSTANTS_USER_MANAGEMENT
                  .EDIT_USER_MANAGEMENT_API_CALL,
                payload: { value: value },
              });
            } else {
              dispatch({
                type: CONSTANTS.CONSTANTS_USER_MANAGEMENT
                  .ADD_USER_MANAGEMENT_API_CALL,
                payload: { value: value },
              });
            }
          }}
        />
      ) : null}
      {modalShowDelete ? (
        <DeleteModalComponent
          title={"Delete User"}
          show={showModalDelete}
          UserManagement
          handleClose={showModalDelete}
          isShow={showModalDelete}
          rowDataUser={cellData}
          roles={useRole}
          addUserManagement={true}
          setValue={(value) => {
            console.log("res2", value);
            isModalShowDelete(false);
            if (cellData != null) {
              setCellClickData(null);
              dispatch({
                type: CONSTANTS.CONSTANTS_USER_MANAGEMENT
                  .EDIT_USER_MANAGEMENT_API_CALL,
                payload: { value: value },
              });
            } else {
              dispatch({
                type: CONSTANTS.CONSTANTS_USER_MANAGEMENT
                  .ADD_USER_MANAGEMENT_API_CALL,
                payload: { value: value },
              });
            }
          }}
        />
      ) : null}

      <div className="col-md-12 col-sm-12 col-12">
        {
          <div
            onClick={() => {
              setCellClickData(null);
            }}
            className="col-md-12 col-sm-12 row-4 icon icon-shape icon-l  me-12"
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "flex-end",
              margin: "2px 0 2px 0px",
            }}
          >
            {loginResponse &&
            loginResponse?.user?.userRoles[0]?.user_role_name ==
              CONSTANTS.CONSTANTS_USER_ROLES.ADMIN ? (
              <DataInput handleFile={importUser} />
            ) : null}
            <div className="ms-md-auto pe-md-3 d-flex align-items-center">
              <div className="input-group">
                <span className="input-group-text text-body">
                  <i className="fas fa-search" aria-hidden="false"></i>
                </span>
                <input
                  aria-label="Search"
                  autoComplete={"false"}
                  data-html={true}
                  data-tip="&amp;#8226; Use atleast 12 characters.<br />
                                    &amp;#8226; Include both lowercase and uppercase characters.<br />
                                    &amp;#8226; Include atleast one number or symbol.<br />
                                    &amp;#8226; Password should not be based on any personal information such as user id, family name, pet, birthday, friends, co-workers, addresses, phone numbers, etc."
                  aria-describedby="basic-addon2"
                  type="text"
                  className="form-control"
                  placeholder="Type here..."
                  onChange={(value) => {
                    let filterData = [];

                    try {
                      if (value.target?.value == "") {
                        filterData = rowDataUser;
                      } else {
                        filterData = rowDataUser?.filter((item) => {
                          return (
                            item.firstName
                              ?.toLowerCase()
                              ?.includes(value.target.value.toLowerCase()) ||
                            item.lastName
                              ?.toLowerCase()
                              ?.includes(value.target.value.toLowerCase()) ||
                            item.email
                              ?.toLowerCase()
                              ?.includes(value.target.value.toLowerCase())
                          );
                        });
                      }
                    } catch (e) {
                      alert("exception " + e);
                    }
                    if (filterData.length > 0) {
                      setRowData(filterData);
                    }
                  }}
                ></input>
              </div>
            </div>

            {loginResponse &&
            (loginResponse?.user?.userRoles[0]?.user_role_name ==
              CONSTANTS.CONSTANTS_USER_ROLES.ADMIN ||
              loginResponse?.user?.userRoles[0]?.user_role_name ==
                CONSTANTS.CONSTANTS_USER_ROLES.RHADMIN) ? (
              <img
                onClick={() => {
                  setCellClickData(null);
                  isModalShow(true);
                }}
                src={require("./../assets/Dashboard/plus.png")}
                style={{
                  display: "flex",
                  alignItems: "flex-end",
                  justifyContent: "flex-end",
                }}
              ></img>
            ) : null}
          </div>
        }
        <div
          className="col-md-12 col-sm-12 row-10 ag-theme-alpine"
          style={{
            height: "80vh",
            width: "80vw",
            margin: "auto",
          }}
        >
          {rowData && rowData?.length > 0 ? (
            <AgGridReact
              ref={gridRef}
              suppressColumnVirtualisation={true}
              defaultColDef={defaultColDef}
              animateRows={true}
              rowSelection="multiple"
              rowData={rowData}
              columnDefs={columnDefs}
            ></AgGridReact>
          ) : (
            <label>{"No data available"}</label>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserManagementComp;
